'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getStyle = function getStyle(element) {
  if (window.getComputedStyle) {
    return document.defaultView.getComputedStyle(element, null);
  }
  if (element.currentStyle) {
    return element.currentStyle;
  }
};

/**
 * Checks if an element is actually visible on the screen
 * In the case where an element was inside a div with the style visibility=hidden,
 * the children wouldn't inherit that style
 * If we had display: none in a css file, it wouldn't show in the dom
 * Both of these styles are in the computed style
 * In general we are making sure an element is visible on the screen, else we should not focus them
 */
var isTrulyHidden = function isTrulyHidden(element) {
  var style = getStyle(element);
  if (style['display'] === 'none' || style['visibility'] === 'hidden' || style['visibility'] === 'collapse' || style['opacity'] === '0' || style['height'] === '0px' && style['width'] === '0px') {
    return true;
  }
  return false;
};

var canFocus = exports.canFocus = function canFocus(element) {
  if (element.readOnly || element.disabled || element.attributes.getNamedItem('disabled') || element.attributes.getNamedItem('readOnly') || isTrulyHidden(element)) {
    return false;
  } else {
    return true;
  }
};

var focusFirstElement = function focusFirstElement(focusableElements) {
  for (var i = 0; i < focusableElements.length; i++) {
    if (focusableElements[i]) {
      var element = focusableElements[i];
      if (canFocus(element)) {
        element.focus();
        return;
      }
    }
  }
};

exports.default = focusFirstElement;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/ElementFocusService.js
// module id = 811
// module chunks = 10